import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

interface SuccessProps {
  type: "mentor" | "scholar";
  onHome: () => void;
}

export function Success({ type, onHome }: SuccessProps) {
  const isMentor = type === "mentor";
  const bgGradient = isMentor
    ? "from-blue-50 to-white"
    : "from-emerald-50 to-white";
  const iconColor = isMentor ? "text-blue-600" : "text-emerald-600";
  const titleColor = isMentor ? "text-blue-900" : "text-emerald-900";

  return (
    <div className={`min-h-screen bg-gradient-to-b ${bgGradient} flex items-center justify-center py-8 px-4`}>
      <Card className="max-w-md w-full text-center">
        <CardHeader className="pb-2">
          <div className="flex justify-center mb-4">
            <CheckCircle className={`h-16 w-16 ${iconColor}`} />
          </div>
          <CardTitle className={`text-2xl ${titleColor}`}>
            Registration Complete!
          </CardTitle>
          <CardDescription className="text-base">
            Thank you for signing up as a {type}.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-muted-foreground">
            {isMentor ? (
              <p>
                We appreciate your commitment to Educational Justice. Our team will review your
                application and reach out soon with next steps to get you matched with a scholar.
              </p>
            ) : (
              <p>
                We're excited to have you join our program! A member of our team will be in
                touch with your guardian shortly to discuss matching you with a mentor.
              </p>
            )}
          </div>

          <div className="bg-muted/50 rounded-lg p-4 text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-2">What happens next?</p>
            <ul className="text-left space-y-2">
              <li>• You'll receive a confirmation email within 24 hours</li>
              <li>• Be sure to check your spam folder</li>
              <li>• The email will contain another set of questions for you to answer to help us match you</li>
              <li>• You will have 5 days to complete this set of questions</li>
              <li>• If you have any questions, please call (502)233-1220</li>
            </ul>
          </div>

          <Button onClick={onHome} variant="outline" className="w-full">
            Return Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
